"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Label = _interopRequireDefault(require("./Label.style"));

var Label = function Label(_ref) {
  var uploads = _ref.uploads,
      percent = _ref.percent,
      timeLeft = _ref.timeLeft;
  var isLoading = percent < 100;
  var isAlone = uploads.length === 1;
  return _react.default.createElement(_Label.default, null, isLoading ? 'Uploading ' : 'Uploaded ', isAlone ? _react.default.createElement("span", {
    className: "UploadBar__fileName"
  }, uploads[0].name) : "".concat(uploads.length, " items"), "...", ' ', isLoading && _react.default.createElement("strong", null, percent, "%"), _react.default.createElement("br", null), isLoading && timeLeft && "About ".concat(timeLeft, " left."));
};

Label.propTypes = {
  uploads: _propTypes.default.array.isRequired,
  percent: _propTypes.default.number.isRequired,
  timeLeft: _propTypes.default.string.isRequired
};
var _default = Label;
exports.default = _default;